import Vue from "vue";
import VueRouter from "vue-router";
// import { store } from "../store";
Vue.use(VueRouter);

function getComponent(path, name) {
  return () => import("../" + path + "/" + name + ".vue");
}

const routes = [
  {
    path: "/",
    name: "Page",
    component: getComponent("views", "Page"),
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: getComponent("components/Worklog", "WorklogView"),
        children: [
          {
            path: "closed-worklogs",
            name: "closed-worklogs",
            component: getComponent("components/Worklog", "ClosedTicketView")
          }
        ]
      },
      {
        path: "create-worklog",
        name: "create-worklog",
        component: getComponent("components/Worklog", "CreateWorklog")
      },
      {
        path: "customers",
        name: "customers",
        component: getComponent("components/Customers", "CustomerView")
      },
      {
        path: "add-customer",
        name: "add-customer",
        component: getComponent("components/Customers", "AddCustomerView")
      },
      {
        path: "options",
        name: "options",
        component: getComponent("components/Options", "Options")
      },
      {
        path: "contracts",
        name: "contracts",
        component: getComponent("components/Contracts", "ContractsView")
      },
      {
        path: "users",
        name: "users",
        component: getComponent("components/Users", "UsersView")
      },
      {
        path: "contracts-create",
        name: "contracts-create",
        component: getComponent("components/Contracts", "ContractCreate")
      },
      {
        path: "contracts-edit",
        name: "contracts-edit",
        component: getComponent("components/Contracts", "ContractCreate")
      },
      {
        path: "edit-worklog",
        name: "edit-worklog",
        component: getComponent("components/Worklog", "EditWorklog")
      },

      {
        path: "worklog-view",
        name: "worklog-view",
        component: getComponent("components/Worklog", "ExecuteWorklogTask")
      },
      {
        path: "add-admin",
        name: "add-admin",
        component: getComponent("components/AdminOptions", "AdminOption")
      },
      {
        path: "add-customer-user",
        name: "add-customer-user",
        component: getComponent("components/Customers", "CustomerUsers")
      },
      {
        path: "units-options",
        name: "units-options",
        component: getComponent("components/Worklog", "UnitsOption")
      },
      {
        path: "work-time-options",
        name: "work-time-options",
        component: getComponent("components/Worklog", "WorkTimeOptions")
      },
      {
        path: "known-problems-options",
        name: "known-problems-options",
        component: getComponent("components/Worklog", "ProblemOptions")
      },
      {
        path: "location-options",
        name: "location-options",
        component: getComponent("components/Worklog", "LocationOptions")
      },
      {
        path: "city-options",
        name: "city-options",
        component: getComponent("components/Worklog", "CityOptions")
      }
    ]
  },
  {
    path: "/helpdesk",
    name: "Clients portal",
    component: getComponent("views", "ClientPortalView"),
    children: [
      {
        path: "",
        name: "Clients Portal",
        component: getComponent(
          "components/ClientsPortal",
          "ClientsWorklogView"
        ),
        children: [
          {
            path: "closed-worklogs",
            name: "closed-worklogs",
            component: getComponent(
              "components/ClientsPortal",
              "ClosedClientsTickets"
            )
          }
        ]
      }
    ]
  },
  {
    path: "/login",
    name: "login",
    component: getComponent("views", "Login"),
    meta: {
      requiresAuth: true
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

/* eslint-disable */
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const user =
    typeof localStorage.getItem("user") === "string"
      ? JSON.parse(localStorage.getItem("user"))
      : null;
  // console.log(user);
  if (!requiresAuth) {
    if (user) {
      next();
    } else {
      next("/login");
    }
  } else {
    next();
  }
});

export default router;
